import React from 'react';
import { Panel, Breadcrumb } from 'rsuite';
import DataTable from './DataTable';
import { useTranslation } from 'react-i18next';

const Page = () => {
  const { t } = useTranslation();
  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Home Office Profiles')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/admin/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active> {t('profiles')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default Page;
